export default __webpack_public_path__ + "static/media/43.91f204ba.jpg";